import React, { useState } from 'react'; 
import CardVertical from './cardVertical';
import CardHorizontalLc from './cardHorizontalLc';
import CardHorizontalHc from './cardHorizontalesHc';
import CardMueble from './cardMuebles';
import CardMaquinarias from './CardMaquinarias';

import vertical1 from "../../productosGaleria/vertical-1.jpg";
import vertical2 from "../../productosGaleria/vertical2.jpg";
import vertical3 from "../../productosGaleria/vertical3.jpg";

import horizontaleslc1 from "../../productosGaleria/horizontales-LC1.jpg";
import horizontaleslc2 from "../../productosGaleria/horizontales-LC2.jpg";
import horizontaleslc3 from "../../productosGaleria/horizontales-LC3.jpg";
import horizontaleslc4 from "../../productosGaleria/horizontales-LC4.jpg";

import horizontaleshc1 from "../../productosGaleria/horizontales-HC1.jpg";
import horizontaleshc2 from "../../productosGaleria/horizontales-HC2.jpg";
import horizontaleshc3 from "../../productosGaleria/horizontales-HC3.jpg";

import mueble1 from "../../productosGaleria/1 Mueble aglomerado archivador.jpeg";
import mueble2 from "../../productosGaleria/2 Mueble aglomerado Buffet .jpeg";
import mueble3 from "../../productosGaleria/3 Mueble aglomerado alacena.jpeg";
import mueble4 from "../../productosGaleria/4 Mubele en madera giratorio con vidrio .jpeg";
import mueble5 from "../../productosGaleria/5 Mueble aglomerado televisor.jpeg";
import mueble6 from "../../productosGaleria/6 Mueble en madera archivador.jpeg";

import maquinaria from "../../productosGaleria/maquinaria.jpeg";
import maquinaria1 from "../../productosGaleria/maquinaria1.jpeg";
import maquinaria2 from "../../productosGaleria/maquinaria2.jpeg";
import maquinaria3 from "../../productosGaleria/maquinaria3.jpeg";

export const galeryScreen = () => {
 
    var CalderaVerticalName = "nombre";

  return ( 
      
     <div>
     <h1 className="my-10 text-center text-red-700">Catalogo de productos</h1>
         <div className="flex flex-wrap my-5 -mx-2">
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardVertical photo={vertical1} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardVertical photo={vertical2} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardVertical photo={vertical3} />
                </div>

                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalLc photo={horizontaleslc1} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalLc photo={horizontaleslc2} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalLc photo={horizontaleslc3} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalLc photo={horizontaleslc4} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalHc photo={horizontaleshc1} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalHc photo={horizontaleshc2} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardHorizontalHc photo={horizontaleshc3} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble1} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble2} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble3} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble4} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble5} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMueble photo={mueble6} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMaquinarias photo={maquinaria} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMaquinarias photo={maquinaria1} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMaquinarias photo={maquinaria2} />
                </div>
                <div className="w-full px-2 my-2 sm:w-1/2 lg:w-1/3">
                    <CardMaquinarias photo={maquinaria3} />
                </div>
            </div>
     </div>
  ); 
} 
 